import axios, { AxiosResponse } from "axios";
import { HTTPResponseModel } from "../../../../../common/models/HTTPResponseModel";
import {  PutT006, PutT007, putT003, putT005 } from "./model";


const API_URL = process.env.REACT_APP_API_URL

const LIST_SERVICE_STATUS = `${API_URL}services/ListServicesStatus`;
//T001
const GET_SERVICE_T001 = `${API_URL}services/GetServiceT001`;
const PUT_SERVICE_T001 = `${API_URL}services/PutServiceT001`;
//T002
const GET_SERVICE_T002 = `${API_URL}services/GetServiceT002`;
const PUT_SERVICE_T002 = `${API_URL}services/PutServiceT002`;
//T003
const GET_SERVICE_T003 = `${API_URL}services/GetServiceT003`;
const PUT_SERVICE_T003 = `${API_URL}services/PutServiceT003`;
//T004
const GET_SERVICE_T004 = `${API_URL}services/GetServiceT004`;
const PUT_SERVICE_T004 = `${API_URL}services/PutServiceT004`;
//T005
const GET_SERVICE_T005 = `${API_URL}services/GetServiceT005`;
const PUT_SERVICE_T005 = `${API_URL}services/PutServiceT005`;
//T006
const GET_SERVICE_T006 = `${API_URL}services/GetServiceT006`;
const PUT_SERVICE_T006 = `${API_URL}services/PutServiceT006`;
//T007
const GET_SERVICE_T007 = `${API_URL}services/GetServiceT007`;
const PUT_SERVICE_T007 = `${API_URL}services/PutServiceT007`;
const GET_DROPDOWN_DATA = `${API_URL}global/DropdownList`;

const GET_SERVICE_T008 = `${API_URL}services/GetServiceT008`;
const PUT_SERVICE_T008 = `${API_URL}services/PutServiceT008`;

export const getListServiceStatus = async (
  Guid: any,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(LIST_SERVICE_STATUS, {
      params : {Guid: Guid}
  })
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
      onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
      onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
      return await getListServiceStatus(Guid, onAccessLost, onToastOrMessage)
  } else if (
      ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
      ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
  ) {
      if (onAccessLost) {
          onAccessLost(ares?.data?.Status?.Message)
      }
  }
  return ares
}

//export T001
export const getServiceT001 = async (
    Guid: any,
    onAccessLost?: (message: string) => void,
    onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
  ): Promise<AxiosResponse<HTTPResponseModel>> => {
    const ares = await axios.get<HTTPResponseModel>(GET_SERVICE_T001, {
        params : {Guid: Guid}
    })
    if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
        onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
    }
    if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
        onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
    }
    if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
        return await getServiceT001(Guid, onAccessLost, onToastOrMessage)
    } else if (
        ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
        ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
    ) {
        if (onAccessLost) {
            onAccessLost(ares?.data?.Status?.Message)
        }
    }
    return ares
  }

export const putServiceT001 = async (
  data: any,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.put<HTTPResponseModel>(PUT_SERVICE_T001,data)
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({
      Message: ares?.data?.Status?.Message,
      MessageType: ares?.data?.Status?.MessageType,
    })
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await putServiceT001(data, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

//export T002
export const getServiceT002 = async (
  Guid: any,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(GET_SERVICE_T002, {
      params : {Guid: Guid}
  })
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
      onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
      onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
      return await getServiceT002(Guid, onAccessLost, onToastOrMessage)
  } else if (
      ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
      ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
  ) {
      if (onAccessLost) {
          onAccessLost(ares?.data?.Status?.Message)
      }
  }
  return ares
}

export const putServiceT002 = async (
  data: any,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.put<HTTPResponseModel>(PUT_SERVICE_T002, data)
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({
      Message: ares?.data?.Status?.Message,
      MessageType: ares?.data?.Status?.MessageType,
    })
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await putServiceT002(data, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}
//export T003
export const getServiceT003 = async (
  Guid: any,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(GET_SERVICE_T003, {
      params : {Guid: Guid}
  })
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
      onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
      onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
      return await getServiceT003(Guid, onAccessLost, onToastOrMessage)
  } else if (
      ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
      ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
  ) {
      if (onAccessLost) {
          onAccessLost(ares?.data?.Status?.Message)
      }
  }
  return ares
}
export const putServiceT003 = async (
  data: putT003,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.put<HTTPResponseModel>(PUT_SERVICE_T003, data)
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({
      Message: ares?.data?.Status?.Message,
      MessageType: ares?.data?.Status?.MessageType,
    })
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await putServiceT003(data, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}
//T004
export const getServiceT004 = async (
  Guid: any,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(GET_SERVICE_T004, {
      params : {Guid: Guid}
  })
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
      onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
      onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
      return await getServiceT004(Guid, onAccessLost, onToastOrMessage)
  } else if (
      ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
      ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
  ) {
      if (onAccessLost) {
          onAccessLost(ares?.data?.Status?.Message)
      }
  }
  return ares
}
export const putServiceT004 = async (
  data: any,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.put<HTTPResponseModel>(PUT_SERVICE_T004, data)
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({
      Message: ares?.data?.Status?.Message,
      MessageType: ares?.data?.Status?.MessageType,
    })
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await putServiceT004(data, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}
//export T005
export const getServiceT005 = async (
  Guid: any,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(GET_SERVICE_T005, {
      params : {Guid: Guid}
  })
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
      onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
      onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
      return await getServiceT005(Guid, onAccessLost, onToastOrMessage)
  } else if (
      ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
      ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
  ) {
      if (onAccessLost) {
          onAccessLost(ares?.data?.Status?.Message)
      }
  }
  return ares
}

export const putServiceT005 = async (
  data: putT005,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.put<HTTPResponseModel>(PUT_SERVICE_T005, data)
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({
      Message: ares?.data?.Status?.Message,
      MessageType: ares?.data?.Status?.MessageType,
    })
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await putServiceT005(data, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

//export T006
export const getServiceT006 = async (
  Guid: string,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(GET_SERVICE_T006, {
      params : {Guid: Guid}
  })
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
      onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
      onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
      return await getServiceT006(Guid, onAccessLost, onToastOrMessage)
  } else if (
      ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
      ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
  ) {
      if (onAccessLost) {
          onAccessLost(ares?.data?.Status?.Message)
      }
  }
  return ares
}

export const putServiceT006 = async (
  data: PutT006,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.put<HTTPResponseModel>(PUT_SERVICE_T006, data)
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({
      Message: ares?.data?.Status?.Message,
      MessageType: ares?.data?.Status?.MessageType,
    })
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await putServiceT006(data, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}
//export T007
export const getServiceT007 = async (
  Guid: any,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(GET_SERVICE_T007, {
      params : {Guid: Guid}
  })
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
      onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
      onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
      return await getServiceT007(Guid, onAccessLost, onToastOrMessage)
  } else if (
      ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
      ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
  ) {
      if (onAccessLost) {
          onAccessLost(ares?.data?.Status?.Message)
      }
  }
  return ares
}
export const putServiceT007 = async (
  data: PutT007,
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.put<HTTPResponseModel>(PUT_SERVICE_T007, data)
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({
      Message: ares?.data?.Status?.Message,
      MessageType: ares?.data?.Status?.MessageType,
    })
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await putServiceT007(data, onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

//dropdownNatureSol
export const getNaturalSolList = async (
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_DROPDOWN_DATA + '?prelistName=NatureSol&T=' + (new Date().getTime())
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getNaturalSolList(onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

//dropdownServing
export const getServingList = async (
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_DROPDOWN_DATA + '?prelistName=Dessertes&T=' + (new Date().getTime())
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getServingList(onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

//dropdownAnchors
export const getAnchorsList = async (
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_DROPDOWN_DATA + '?prelistName=Ancrages&T=' + (new Date().getTime())
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getAnchorsList(onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

//dropdownObstacleSol
export const getObstacleSolList = async (
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_DROPDOWN_DATA + '?prelistName=ObstacleSol&T=' + (new Date().getTime())
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getObstacleSolList(onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

//dropdownObstacleHauter
export const getObstacleHauterList = async (
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_DROPDOWN_DATA + '?prelistName=ObstacleHauteur&T=' + (new Date().getTime())
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getObstacleHauterList(onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

//dropdownPositionnement
export const getPositionnementList = async (
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_DROPDOWN_DATA + '?prelistName=Positionnement&T=' + (new Date().getTime())
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getPositionnementList(onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

//dropdownChargement
export const getChargementList = async (
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_DROPDOWN_DATA + '?prelistName=Chargement&T=' + (new Date().getTime())
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getChargementList(onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

//dropdownObstacleSol
export const getPositionMatList = async (
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_DROPDOWN_DATA + '?prelistName=PositionMat&T=' + (new Date().getTime())
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getPositionMatList(onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}

////dropdownT005
export const getPrelistName = async (
  onAccessLost?: (message: string) => void,
  onToastOrMessage?: (toastOrMessage: {
    Message?: string
    MessageType?: string
    Toast?: string
    ToastType?: string
  }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
  const ares = await axios.get<HTTPResponseModel>(
    GET_DROPDOWN_DATA + '?prelistName=Agency&T=' + (new Date().getTime())
  )
  if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
    onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
  }
  if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
    onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
  }
  if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
    return await getPrelistName(onAccessLost, onToastOrMessage)
  } else if (
    ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
    ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)' ||
    ares?.data?.Status?.FailureReason === 'Session expired'
  ) {
    if (onAccessLost) {
      onAccessLost(ares?.data?.Status?.Message)
    }
  }
  return ares
}


//load T008Data
export const getServiceT008 = async (
    Guid: any,
    onAccessLost?: (message: string) => void,
    onToastOrMessage?: (toastOrMessage: {
        Message?: string
        MessageType?: string
        Toast?: string
        ToastType?: string
    }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
    const ares = await axios.get<HTTPResponseModel>(GET_SERVICE_T008,{
        params: {
            Guid: Guid
        }
    })
    if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
        onToastOrMessage({
            Message: ares?.data?.Status?.Message,
            MessageType: ares?.data?.Status?.MessageType,
        })
    }
    if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
        onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
    }
    if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
        return await getServiceT008(Guid, onAccessLost, onToastOrMessage)
    } else if (
        ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
        ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
    ) {
        if (onAccessLost) {
            onAccessLost(ares?.data?.Status?.Message)
        }
    }
    return ares
}

export const putServiceT008 = async (
    data: any,
    onAccessLost?: (message: string) => void,
    onToastOrMessage?: (toastOrMessage: {
        Message?: string
        MessageType?: string
        Toast?: string
        ToastType?: string
    }) => void
): Promise<AxiosResponse<HTTPResponseModel>> => {
    const ares = await axios.put<HTTPResponseModel>(PUT_SERVICE_T008,data)
    if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
        onToastOrMessage({
            Message: ares?.data?.Status?.Message,
            MessageType: ares?.data?.Status?.MessageType,
        })
    }
    if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
        onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
    }
    if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
        return await putServiceT008(data, onAccessLost, onToastOrMessage)
    } else if (
        ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
        ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
    ) {
        if (onAccessLost) {
            onAccessLost(ares?.data?.Status?.Message)
        }
    }
    return ares
}
